// client/src/modules/billing/nav.ts
import type { NavItem } from '../types';

/** Held invoice-to-ticket links awaiting a person's decision (#3464). Navigation shows a live count on it. */
export const LINK_REVIEW_PATH = '/billing/invoicing/link-review';

/**
 * Finance menu — the tree Nick agreed on 2026-10-15 (FIN-D1): each job has one place.
 *
 *   Dashboard  — how we are doing, and where the piles of work are
 *   Invoice ▾  — make and find invoices: Service Invoicing, Project Invoicing, Customers, Invoices
 *   Collect    — chase what is owed
 *   Tools ▾    — Link Review (live count badge, keyed on LINK_REVIEW_PATH), Parts Repricing,
 *                Inventory Reconciler, Agent Activity
 *   Settings
 *
 * Ready to Bill is part of Service Invoicing (FIN-D6). Old addresses keep working through the redirects in routes.tsx.
 *
 * Note: Nav component supports one level of children (dropdown). A dropdown's own path is its first child.
 */
export const navItems: NavItem[] = [
  { label: 'Dashboard', path: '/billing/dashboard' },
  {
    label: 'Invoice',
    path: '/billing/invoicing/service',
    children: [
      { label: 'Service Invoicing', path: '/billing/invoicing/service' },
      { label: 'Project Invoicing', path: '/billing/invoicing/projects' },
      { label: 'Customers', path: '/billing/customers' },
      { label: 'Invoices', path: '/billing/invoicing' },
    ],
  },
  { label: 'Collect', path: '/billing/collections' },
  {
    label: 'Tools',
    path: LINK_REVIEW_PATH,
    children: [
      { label: 'Link Review', path: LINK_REVIEW_PATH },
      { label: 'Parts Repricing', path: '/billing/tools/repricing' },
      { label: 'Inventory Reconciler', path: '/billing/tools/inventory-reconciler' },
      { label: 'Agent Activity', path: '/billing/agent-activity' },
    ],
  },
  { label: 'Settings', path: '/billing/settings' },
];
